import { analytics } from "@/lib/analytics/ga4";
import { createLogger } from "@/lib/observability/logger";
import { AuthError, getAuth, sendPasswordResetEmail } from "firebase/auth";
import { sanitizeFirebaseError } from "../util/sanitizeFirebaseError";

export async function sendPasswordReset(email: string) {
  const logger = createLogger("sendPasswordReset");
  const auth = getAuth();
  try {
    await sendPasswordResetEmail(auth, email);
    analytics.event({
      action: "password_reset",
      category: "auth",
      custom_parameters: {
        email,
        status: "success",
      },
    });
  } catch (error) {
    const authError = error as AuthError;
    const { sanitizedMessage, errorCode } = sanitizeFirebaseError(authError);

    logger.error(
      `Unable to send password reset email.\n Code: ${errorCode}`,
      error as Error,
      {
        email,
        errorCode,
      },
    );

    analytics.event({
      action: "password_reset",
      category: "auth",
      custom_parameters: {
        email,
        errorCode,
      },
    });

    throw new Error(sanitizedMessage);
  }
}
